// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_m7-0";
export var buttonContainer = "_m7-3";
export var cancelButton = "_m7-4";
export var headerSection = "_m7-6";
export var headerTitle = "_m7-9";
export var messageSideLeft = "_m7-1";
export var messageSideRight = "_m7-2";
export var orderNumberContainer = "_m7-7";
export var orderNumberLabel = "_m7-8";
export var submitButton = "_m7-5";